"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _2 = require("./..");

var _lodash = _interopRequireDefault(require("lodash"));

var _reactShare = require("react-share");

var _reactUseClipboard = _interopRequireDefault(require("react-use-clipboard"));

var whatsappPropTypes = _propTypes.default.shape({
  title: _propTypes.default.string,
  separator: _propTypes.default.string
});

var facebookPropTypes = _propTypes.default.shape({
  quote: _propTypes.default.string,
  hashtag: _propTypes.default.string
});

var twitterPropTypes = _propTypes.default.shape({
  title: _propTypes.default.string,
  via: _propTypes.default.string,
  hashtags: _propTypes.default.arrayOf(_propTypes.default.string),
  related: _propTypes.default.string
});

var emailPropTypes = _propTypes.default.shape({
  subject: _propTypes.default.string,
  body: _propTypes.default.string,
  separator: _propTypes.default.string
});

var telegramPropTypes = _propTypes.default.shape({
  title: _propTypes.default.string
});

var pinterestPropTypes = _propTypes.default.shape({
  media: _propTypes.default.string.isRequired,
  description: _propTypes.default.string
});

var linePropTypes = _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.shape({
  title: _propTypes.default.string
})]);

var redditPropTypes = _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.shape({
  title: _propTypes.default.string
})]);

var CopyUrlIconButton = function CopyUrlIconButton(_ref) {
  var routeToCopy = _ref.routeToCopy;

  var _useClipboard = (0, _reactUseClipboard.default)(routeToCopy, {
    successDuration: 1000
  }),
      isCopied = _useClipboard[0],
      setCopied = _useClipboard[1];

  return /*#__PURE__*/_react.default.createElement(_2.IconButton, {
    icon: isCopied ? 'fas fa-check' : 'fas fa-link',
    variant: "outline",
    size: "s",
    onClick: setCopied
  });
};

CopyUrlIconButton.propTypes = {
  routeToCopy: _propTypes.default.string
};
var sizeMappings = {
  s: 32 + 1,
  m: 36 + 1,
  l: 44 + 1
};

var ShareButtons = function ShareButtons(_ref2) {
  var size = _ref2.size,
      sharedRoute = _ref2.sharedRoute,
      sharedTitle = _ref2.sharedTitle,
      sharedDescription = _ref2.sharedDescription,
      whatsapp = _ref2.whatsapp,
      facebook = _ref2.facebook,
      twitter = _ref2.twitter,
      email = _ref2.email,
      telegram = _ref2.telegram,
      pinterest = _ref2.pinterest,
      line = _ref2.line,
      reddit = _ref2.reddit;
  var iconSize = sizeMappings[size];
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(CopyUrlIconButton, {
    routeToCopy: sharedRoute
  }), whatsapp && /*#__PURE__*/_react.default.createElement(_reactShare.WhatsappShareButton, {
    url: sharedRoute,
    title: _lodash.default.get(whatsapp, 'title', sharedTitle),
    separator: _lodash.default.get(whatsapp, 'separator')
  }, /*#__PURE__*/_react.default.createElement(_reactShare.WhatsappIcon, {
    size: iconSize,
    round: true
  })), facebook && /*#__PURE__*/_react.default.createElement(_reactShare.FacebookShareButton, {
    url: sharedRoute,
    quote: _lodash.default.get(facebook, 'quote', sharedTitle),
    hashtag: facebook.hashtag && "#" + facebook.hashtag
  }, /*#__PURE__*/_react.default.createElement(_reactShare.FacebookIcon, {
    size: iconSize,
    round: true
  })), twitter && /*#__PURE__*/_react.default.createElement(_reactShare.TwitterShareButton, {
    url: sharedRoute,
    title: _lodash.default.get(twitter, 'title', sharedTitle),
    via: _lodash.default.get(twitter, 'via'),
    hashtags: _lodash.default.get(twitter, 'hashtags'),
    related: _lodash.default.get(twitter, 'related')
  }, /*#__PURE__*/_react.default.createElement(_reactShare.TwitterIcon, {
    size: iconSize,
    round: true
  })), email && /*#__PURE__*/_react.default.createElement(_reactShare.EmailShareButton, {
    url: sharedRoute,
    subject: _lodash.default.get(email, 'subject', sharedTitle),
    body: _lodash.default.get(email, 'body', sharedDescription),
    separator: _lodash.default.get(email, 'separator')
  }, /*#__PURE__*/_react.default.createElement(_reactShare.EmailIcon, {
    size: iconSize,
    round: true
  })), telegram && /*#__PURE__*/_react.default.createElement(_reactShare.TelegramShareButton, {
    url: sharedRoute,
    title: _lodash.default.get(telegram, 'title', sharedTitle)
  }, /*#__PURE__*/_react.default.createElement(_reactShare.TelegramIcon, {
    size: iconSize,
    round: true
  })), _lodash.default.get(pinterest, 'media') && /*#__PURE__*/_react.default.createElement(_reactShare.PinterestShareButton, {
    url: sharedRoute,
    media: pinterest.media,
    description: _lodash.default.get(pinterest, 'description', sharedDescription)
  }, /*#__PURE__*/_react.default.createElement(_reactShare.PinterestIcon, {
    size: iconSize,
    round: true
  })), line && /*#__PURE__*/_react.default.createElement(_reactShare.LineShareButton, {
    url: sharedRoute,
    title: _lodash.default.get(line, 'title', sharedTitle)
  }, /*#__PURE__*/_react.default.createElement(_reactShare.LineIcon, {
    size: iconSize,
    round: true
  })), reddit && /*#__PURE__*/_react.default.createElement(_reactShare.RedditShareButton, {
    url: sharedRoute,
    title: _lodash.default.get(reddit, 'title', sharedTitle)
  }, /*#__PURE__*/_react.default.createElement(_reactShare.RedditIcon, {
    size: iconSize,
    round: true
  })));
};

ShareButtons.propTypes = {
  /** It specifies the size */
  size: _propTypes.default.oneOfType([_propTypes.default.oneOf(['s', 'm', 'l']), _propTypes.default.string]),
  sharedRoute: _propTypes.default.string.isRequired,
  sharedTitle: _propTypes.default.string.isRequired,
  sharedDescription: _propTypes.default.string.isRequired,
  whatsapp: whatsappPropTypes,
  facebook: facebookPropTypes,
  twitter: twitterPropTypes,
  email: emailPropTypes,
  telegram: telegramPropTypes,
  pinterest: pinterestPropTypes,
  line: linePropTypes,
  reddit: redditPropTypes
};
ShareButtons.defaultProps = {
  size: 'm'
};
var _default = ShareButtons;
exports.default = _default;